import type { SxProps, Theme } from '@mui/material';
import type { CSSProperties } from 'react';

/**
 * Outer Box sx — stretches to fill the TableCell absolutely.
 * Use this as the root container for all filter input components.
 */
export const filterCellBoxSx: SxProps<Theme> = {
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  display: 'flex',
  alignItems: 'center',
  padding: '0 8px',
};

/**
 * Operator IconButton sx — compact, subtle border-radius.
 */
export const operatorButtonSx: SxProps<Theme> = {
  padding: '4px',
  borderRadius: '4px',
  flexShrink: 0,
  width: '28px',
  height: '28px',
};

/**
 * Divider sx — sits flush after the operator button.
 * marginLeft/marginRight: '6px' gives even spacing on both sides.
 */
export const filterDividerSx: SxProps<Theme> = {
  marginLeft: '6px',
  marginRight: '6px',
  flexShrink: 0,
};

/**
 * Native <input> base style — fills remaining space inside the flex row.
 * Import the existing filterInputBaseStyle and spread it; this adds the
 * layout properties that make the input stretch correctly.
 */
export const filterNativeInputStyle: CSSProperties = {
  border: 'none',
  outline: 'none',
  background: 'transparent',
  height: '100%',
  flex: 1,
  minWidth: 0,
  paddingLeft: '4px',
  paddingRight: '4px',
};
